import { OrganizationAutocomplete } from "@/components/shared/OrganizationAutocomplete";
import { TextField } from "@/components/shared/TextField";
import { Stack } from "@mui/material";
import { useCallback } from "react";
import { IImportFormData } from "./types";

interface DetailsStepProps {
    formData: IImportFormData;
    onFormDataChange: (formData: IImportFormData) => void;
}

export const DetailsStep = ({
    formData,
    onFormDataChange,
}: DetailsStepProps) => {
    const updateFormData = useCallback(
        (updates: Partial<IImportFormData>) => {
            onFormDataChange({ ...formData, ...updates });
        },
        [formData, onFormDataChange]
    );

    const handleNameChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            updateFormData({ name: e.target.value });
        },
        [updateFormData]
    );

    const handleDescriptionChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            updateFormData({ description: e.target.value });
        },
        [updateFormData]
    );

    const handleOrganizationChange = useCallback(
        (orgId: number | null) => {
            updateFormData({ organizationId: orgId ?? undefined });
        },
        [updateFormData]
    );

    const handleOrganizationNameChange = useCallback(
        (name: string | null) => {
            updateFormData({ organizationName: name ?? undefined });
        },
        [updateFormData]
    );

    return (
        <Stack gap={3}>
            {/* Checklist Name */}
            <TextField
                label="Checklist Name"
                placeholder="Enter checklist name"
                required
                value={formData.name}
                onChange={handleNameChange}
            />

            {/* Description */}
            <TextField
                label="Description"
                multiline
                required
                minRows={3}
                maxRows={6}
                placeholder="Provide a brief description of the checklist"
                value={formData.description}
                onChange={handleDescriptionChange}
            />

            {/* Organization */}
            <OrganizationAutocomplete
                value={formData.organizationId ?? null}
                onChange={handleOrganizationChange}
                onChangeName={handleOrganizationNameChange}
                required
            />
        </Stack>
    );
};
